import TKModal from "./Modal";

const Founder2Modal = ({ isOpen, onClose2 }) => {
  return (
    <TKModal open={isOpen} onClose={onClose2} noHeader>
      <div className="flex flex-col gap-4">
        <div>
          <p className="font-bold text-[30px] uppercase">Chinenye Etoniru</p>
          <p className="text-[18px] text-[#7A7A7A]">Co-Founder</p>
        </div>
        <div>
          <p className="text-[#7A7A7A] text-[18px]">
            Chinenye is an experienced social impact strategist and a certified
            project management professional with a combined experience of 9
            years across the social impact and tech industries.
          </p>
        </div>
        <div>
          <p className="text-[#7A7A7A] text-[18px]">
            In 2014, She began her career in LEAP Africa where she designed and
            coordinated various donor funded programs that empowered thousands
            of African youth and connected them to economic opportunities in
            their localities. After LEAP Africa, She transitioned into the tech
            industry and in 2020 served as the COO and Principal Growth
            Consultant at Algrowithm ( a digital growth agency) where she led
            the development and execution of go to market and growth strategies
            for some of Africa’s leading startups and accelerators.
          </p>
        </div>
        <div>
          <p className="text-[#7A7A7A] text-[18px]">
            Chinenye is passionate about the use of innovation to scale social
            impact in Africa. She is continuously inspired by her vision to see
            Africa arise and come into her full potential.
          </p>
        </div>
      </div>
    </TKModal>
  );
};

export default Founder2Modal;
